import React from "react";
import { cn } from "@/lib/utils";
import { formatPriceMonthlyCents } from "@/lib/billingApi";
import { planDisplayName } from "@/lib/planMarketing";

function formatBytes(n) {
  const v = Number(n) || 0;
  if (v < 1024) return `${v} B`;
  if (v < 1024 * 1024) return `${(v / 1024).toFixed(0)} KB`;
  if (v < 1024 * 1024 * 1024) return `${(v / (1024 * 1024)).toFixed(0)} MB`;
  return `${(v / (1024 * 1024 * 1024)).toFixed(0)} GB`;
}

/**
 * Plan cards from GET /billing/plan-catalog.
 */
export default function PlanCatalogPicker({
  catalog,
  selectedPlan,
  onSelect,
  disabled,
  hideEnterprise = false,
}) {
  const plans = (catalog || []).filter(
    (p) => !hideEnterprise || p.plan !== "enterprise"
  );

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {plans.map((p) => {
        const contact = p.contact_sales || p.plan === "enterprise";
        const selected = selectedPlan === p.plan;
        const price = contact
          ? "Contact sales"
          : `${formatPriceMonthlyCents(p.price_monthly_cents)}/mo`;
        return (
          <button
            key={p.plan}
            type="button"
            disabled={disabled || contact}
            onClick={() => !contact && onSelect?.(p.plan)}
            className={cn(
              "rounded-lg border p-3 text-left transition-colors",
              selected
                ? "border-primary bg-primary/10"
                : "border-border hover:border-primary/40",
              (disabled || contact) && "opacity-80"
            )}
          >
            <div className="flex items-baseline justify-between gap-2">
              <span className="font-semibold">{planDisplayName(p.plan)}</span>
              <span className="text-sm tabular-nums text-muted-foreground">
                {price}
              </span>
            </div>
            <ul className="mt-2 space-y-0.5 text-xs text-muted-foreground">
              <li>
                Seats:{" "}
                {p.seat_limit == null ? "Unlimited" : p.seat_limit}
              </li>
              <li>
                Storage:{" "}
                {p.storage_quota_bytes == null
                  ? "Unlimited"
                  : formatBytes(p.storage_quota_bytes)}
              </li>
              <li>
                AI catch-up / mo:{" "}
                {p.ai_catchup_monthly == null
                  ? "Unlimited"
                  : p.ai_catchup_monthly}
              </li>
              {p.modules?.sso ? (
                <li>SSO / IdP included</li>
              ) : (
                <li>Email sign-in (SSO on Business+)</li>
              )}
            </ul>
            {contact && (
              <a
                href="mailto:sales@circa.example?subject=Circa%20Enterprise"
                className="mt-2 inline-block text-xs font-medium text-primary underline"
                onClick={(e) => e.stopPropagation()}
              >
                Contact sales
              </a>
            )}
          </button>
        );
      })}
    </div>
  );
}
